<template>
    <a :href="url">
      <div class="product-card">
          <div class="product-img">
              <div class="product-campaigns">
                  <label v-if="ih" class="product-campaign itsehoitolaake-campaign">
                    <span>
                        <svg class="svg-inline--fa fa-band-aid fa-w-20" aria-hidden="true" data-prefix="fas" data-icon="band-aid" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" data-fa-i2svg=""><path fill="currentColor" d="M0 160v192c0 35.3 28.7 64 64 64h96V96H64c-35.3 0-64 28.7-64 64zm576-64h-96v320h96c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64zM192 416h256V96H192v320zm176-232c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm0 96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-96-96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm0 96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24z"></path></svg>
                      {{translations.ihproduct}}
                    </span>
                  </label>
                  <label v-if="isMedical" class="product-campaign laite-campaign">
                    <span><span class="ce-mark"/>{{translations.medicalinstrument}}</span>
                  </label>
                  <label v-if="isSupplement" class="product-campaign ravintolisa-campaign">
                    <span>
                        <svg class="svg-inline--fa fa-pills fa-w-18" aria-hidden="true" data-prefix="fas" data-icon="pills" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" data-fa-i2svg=""><path fill="currentColor" d="M112 32C50.1 32 0 82.1 0 144v224c0 61.9 50.1 112 112 112s112-50.1 112-112V144c0-61.9-50.1-112-112-112zm48 224H64V144c0-26.5 21.5-48 48-48s48 21.5 48 48v112zm139.7-29.7c-3.5-3.5-9.4-3.1-12.3.8-45.3 62.5-40.4 150.1 15.9 206.4 56.3 56.3 143.9 61.2 206.4 15.9 4-2.9 4.3-8.8.8-12.3L299.7 226.3zm229.8-19c-56.3-56.3-143.9-61.2-206.4-15.9-4 2.9-4.3 8.8-.8 12.3l210.8 210.8c3.5 3.5 9.4 3.1 12.3-.8 45.3-62.6 40.5-150.1-15.9-206.4z"></path></svg>
                        {{translations.supplement}}
                    </span>
                  </label>
                  <label v-if="newProduct" class="product-campaign uutuustuote-campaign">
                    <span>
                        <svg class="svg-inline--fa fa-star fa-w-18" aria-hidden="true" data-prefix="fas" data-icon="star" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" data-fa-i2svg=""><path fill="currentColor" d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path></svg>
                        {{translations.newproduct}}
                    </span>
                  </label>
                  <label v-if="CollectableCampaign" class="product-campaign collectable-campaign">
                    <span>
                        <svg class="svg-inline--fa fa-shopping-basket fa-w-18" aria-hidden="true" data-prefix="fas" data-icon="shopping-basket" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" data-fa-i2svg=""><path fill="currentColor" d="M576 216v16c0 13.255-10.745 24-24 24h-8l-26.113 182.788C514.509 462.435 494.257 480 470.37 480H105.63c-23.887 0-44.139-17.565-47.518-41.212L32 256h-8c-13.255 0-24-10.745-24-24v-16c0-13.255 10.745-24 24-24h67.341l106.78-146.821c10.395-14.292 30.407-17.453 44.701-7.058 14.293 10.395 17.453 30.408 7.058 44.701L170.477 192h235.046L326.12 82.821c-10.395-14.292-7.234-34.306 7.059-44.701 14.291-10.395 34.306-7.235 44.701 7.058L484.659 192H552c13.255 0 24 10.745 24 24zM312 392V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24zm112 0V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24zm-224 0V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24z"></path></svg>
                        Keräilytuote
                    </span>
                  </label>
                  <label v-if="CorrectCampaigns.length > 0" class="product-campaign other-campaign">
                    <span>
                        <svg class="svg-inline--fa fa-tag fa-w-16" aria-hidden="true" data-prefix="fas" data-icon="tag" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""><path fill="currentColor" d="M0 252.118V48C0 21.49 21.49 0 48 0h204.118a48 48 0 0 1 33.941 14.059l211.882 211.882c18.745 18.745 18.745 49.137 0 67.882L293.823 497.941c-18.745 18.745-49.137 18.745-67.882 0L14.059 286.059A48 48 0 0 1 0 252.118zM112 64c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z"></path></svg>
                        Kampanjatuote
                    </span>
                  </label>
              </div>
            <img :src="imageUrl" :alt="imageAlt" loading="lazy">
          </div>
          <p>{{name}}</p>
      </div>
    </a>  
</template>
<script>
export default {
  props: {
    imageUrl: "",
    imageAlt: "",
    name: "",
    url: "",
    ih: false,
    isMedical: false,
    isSupplement: true,
    newProduct: false,
    id: Number,
    campaigns: Array,
    translations: Object
  },
  computed: {
    CorrectCampaigns(){
      return this.campaigns.filter(c => c.products.includes(this.id) && !c.collectable);
    },
    CollectableCampaign(){
      return this.campaigns.filter(c => c.products.includes(this.id) && c.collectable)[0];
    }
  }
}
</script>
